import Phaser from 'phaser';
import { AudioScene } from '../AudioScene';

export class Button extends Phaser.GameObjects.Container {
  private readonly buttonImage: Phaser.GameObjects.Image;

  constructor(scene, x, y, name, method, clickSound='', width = 151, height = 49) {
    super(scene);
    this.scene = scene;
    this.x = x;
    this.y = y;
    this.buttonImage = this.scene.add
      .image(0, 0, name + '-btn')
      .setInteractive({ useHandCursor: true })
      .setDisplaySize(width, height);

    this.add(this.buttonImage);


    this.buttonImage.on('pointerdown', () => {
      this.animateButtonPress();
      method();
      if (clickSound !== '' && typeof this.scene !== 'undefined' && typeof (this.scene as AudioScene) !== 'undefined') {
        (this.scene as AudioScene).getAudioManager().playSoundEffect(clickSound);
      }
    });

    this.scene.add.existing(this);
  }

  public getButtonImage() {
    return this.buttonImage;
  }

  private animateButtonPress = () => {
    this.buttonImage.disableInteractive();
    const self = this;
    this.scene.tweens.add({
      targets: this.buttonImage,
      duration: 80,
      yoyo: true,
      scale: this.buttonImage.scale - 0.5,
      onComplete: () => {
        if (typeof self.scene !== 'undefined') {
          self.buttonImage.setInteractive({ userHandCursor: true });
        }
      }
    });
  }
}
